import { render } from "./shangLvDiscountModel.vue?vue&type=template&id=17b84a87"
import script from "./shangLvDiscountModel.vue?vue&type=script&lang=js"
export * from "./shangLvDiscountModel.vue?vue&type=script&lang=js"

import "./shangLvDiscountModel.vue?vue&type=style&index=0&id=17b84a87&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__